<template>
  <span
    v-if="aiSummary?.summary?.updatedAt"
    class="text-static-default-low flex shrink-0 items-center justify-end gap-4 py-6"
  >
    {{ i18n(translations.caption) }}

    <RevTooltip>
      <template #trigger="{ show, hide }">
        <IconInfo
          class="inline"
          size="16"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        />
      </template>

      {{ tooltipText }}
    </RevTooltip>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ReviewsAISummary } from '@backmarket/nuxt-layer-reviews/api/reviews/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './AIInfo.translations'

const i18n = useI18n()

const props = defineProps<{
  aiSummary: ReviewsAISummary | undefined | null
}>()

const AI_SUMMARY_REVIEW_COUNT_THRESHOLD = 1000

const formattedUpdatedAt = computed(() => {
  if (!props.aiSummary?.summary?.updatedAt) return ''

  return i18n.date(new Date(props.aiSummary.summary.updatedAt))
})

const tooltipText = computed(() => {
  if (!props.aiSummary?.summary?.reviewsCount) return ''
  if (
    props.aiSummary.summary.reviewsCount > AI_SUMMARY_REVIEW_COUNT_THRESHOLD
  ) {
    return i18n(translations.tooltip, {
      updateDate: formattedUpdatedAt.value,
    })
  }
  if (
    props.aiSummary?.summary?.reviewsCount === AI_SUMMARY_REVIEW_COUNT_THRESHOLD
  ) {
    return i18n(translations.tooltipLatestReviews, {
      number: AI_SUMMARY_REVIEW_COUNT_THRESHOLD,
      updateDate: formattedUpdatedAt.value,
    })
  }

  return i18n(translations.tooltipAllReviews, {
    updateDate: formattedUpdatedAt.value,
  })
})
</script>
